<template>
    <div class="mpS4">
        <div class="mpS4-title">ON STYLE LIVE는 무엇이 다른가?</div>
        <div class="mpS4-box box-bg">
            <div class="box-title">START</div>
            <div class="box-cont">
                복잡하고 어려운 입점 절차는 이제 NONO!!
                ON STYLE LIVE에서는 <strong>무료
                    입점</strong>과 <strong>입점 절차 최소화</strong>로 누구나 쉽고 간편하게 입점할수
                있도록 도와드리고 있습니다.
            </div>
        </div>
        <div class="mpS4-box">
            <div class="box-title">Easy</div>
            <div class="box-cont">
                별다른 방송장비 필요없이 모바일 하나로 셀카 찍듯히 EASY!!
                <strong>언제 어디서나 시작 버튼 하나로</strong>
                간편하고 빠르게 방송 진행할수
                있으며 글로 표현하기 힘든 정보를 방송으로 <strong>상세하고 디테일</strong>하게 전달할수 있습니다.
            </div>
        </div>
            <div class="mpS4-box box-bg">
                <div class="box-title">Save</div>
                <div class="box-cont">
                    비싸기만 한 광고비 지출은 이제 BYE BYE~~
                    ON STYLE LIVE에서 실시간
                    라이브 스트리밍 방송으로 직접
                    상품에 대해 홍보하고 각종 이벤트
                    기획전을 신청해 <strong>무의미한 광고비
                        지출을 아껴보세요.</strong>
                </div>
            </div>
            <div class="mpS4-box">
                <div class="box-title">Interactive</div>
                <div class="box-cont">
                    서로 소통하고 공감하며 고객의 소리에 귀 기울이기!!
                    실시간 방송으로 <strong>소비자와 소통</strong>하고 고객들의 궁금증을 바로바로
                    해결해주며 팬덤을 확보하여 내
                    쇼핑몰의 <strong>단골고객</strong>으로 만들어보아요.
                </div>
            </div>
        </div>
</template>
<script>
    export default {
        name: "mpSlide4"
    }
</script>
<style lang="scss" scoped>
    .mpS4 {
        width: 100%;
        padding: 50px 15px 30px 15px;
        box-sizing: border-box;
        position: relative;

        .mpS4-title {
            font-size: 20px;
            font-weight: 900;
            color: #272727;
            text-align: center;
            margin-bottom: 30px;
        }

        .mpS4-box {
            width: 100%;
            padding: 20px 20px 30px 20px;
            box-sizing: border-box;
            border: 1px solid #f4f4f4;
            display: flex;
            flex-direction: column;
            align-items: center;
            border-radius: 10px;
            margin-bottom: 30px;

            .box-title {
                font-size: 18px;
                font-weight: 900;
                color: #ff5c5c;
                margin-bottom: 10px;
            }

            .box-cont {
                color: #6f6f6f;
                text-align: center;

            }
        }
        .box-bg {
            background-color: #f4f4f4;
            border: none;
        }

    }
</style>